var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-4",attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_c('subscription-info')],1),_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_c('card-info')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }